export const SegmentEvents = {
  signupSuccess: 'Signup Success',
  loggedIn: 'Login',
  mapPropertyAdded: 'Map Property Added',
  mapRetailerAdded: 'Map Retailer Added',
  mapMarkerAdded: 'Map Marker Added',
  mapPropertyEdited: 'Map Property Edited',
  mapPropertyHidden: 'Map Property Hidden',
  mapPropertyRemoved: 'Map Property Removed',
  mapRetailerClicked: 'Map Retailer Clicked',
  mapRetailerMoved: 'Map Retailer Moved',
  mapRetailerEdited: 'Map Retailer Edited',
  mapRetailerHidden: 'Map Retailer Hidden',
  mapRetailerRemoved: 'Map Retailer Removed',
  mapSaved: 'Map Saved',
  mapShared: 'Map Shared',
  mapMyStuffClicked: 'Map "My Stuff" Clicked'
};



// WEBPACK FOOTER //
// ./src/app/modules/maps-add-stuff/constants/SegmentEvents.ts